import { createLogger, format, transports } from 'winston';
import isError from 'lodash/isError';

/*
  Documentation 
    https://betterstack.com/community/guides/logging/how-to-install-setup-and-use-winston-and-morgan-to-log-node-js-applications/
*/
export const logger = createLogger({
  level: process.env.LOGGING_LEVEL || 'info',
  exitOnError: false,
  format: format.json(),
  transports: [new transports.Console()],
});

export const enrich = (data: object | Error) => ({
  ...data,
  ...(isError(data)
    ? {
        error: {
          kind: data.name,
          message: data.message,
          stack: data.stack,
        },
      }
    : {}),
});

export const log = (level: string) => (data: any, message: string) =>
  (logger[level] || logger.log)(message, enrich(data));

export const error = log('error');
export const warn = log('warn');
export const info = log('info');
export const verbose = log('verbose');
export const debug = log('debug');
export const silly = log('silly');

export const event = (event: string, data: any, message: string) =>
  info(
    {
      event: {
        [event]: data,
      },
    },
    message
  );
